import * as z from "zod";

// Profiles
export const ListProfilesRequestSchema = z.object({});
export const ListProfilesResponseSchema = z.object({
  profiles: z.array(z.any()),
});
export type ListProfilesRequest = z.infer<typeof ListProfilesRequestSchema>;
export type ListProfilesResponse = z.infer<typeof ListProfilesResponseSchema>;

// Integrations
export const IntegrationV2ResponseSchema = z.object({}).passthrough();
export const GetIntegrationsV2ResponseSchema = z.object({
  integrations: z.array(z.any()),
});
export const IntegrationCredentialsSchema = z.object({}).passthrough();
export const IntegrationMetadataSchema = z.object({}).passthrough();
export const IntegrationTypeSchema = z.enum(["gtm", "shopify", "other"]);

export type IntegrationV2Response = z.infer<typeof IntegrationV2ResponseSchema>;
export type GetIntegrationsV2Response = z.infer<
  typeof GetIntegrationsV2ResponseSchema
>;
export type IntegrationCredentials = z.infer<
  typeof IntegrationCredentialsSchema
>;
export type IntegrationMetadata = z.infer<typeof IntegrationMetadataSchema>;
export type IntegrationType = z.infer<typeof IntegrationTypeSchema>;

// Client
export class SlytherinClient {
  async listProfiles(): Promise<ListProfilesResponse> {
    return { profiles: [] };
  }
}
